import { getAccountPropertiesAsync } from './getAccountPropertiesAsync'

export const getAccountIdAsync = async (refresh = false) => {
  try {
    const account = await getAccountPropertiesAsync(refresh)

    return 'id' in account ? account.id : undefined
  } catch (err) {
    return null
  }
}
